import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CommonsService } from 'src/app/services/commons.service';

/**
 * Componennte para el header generico
 */
@Component({
  standalone: false,
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  /**
   * Guarda si mostrar el icono o no
   */
  hideIcon: boolean;
  /**
   * Show icon of header component
   */
  showIcon = 1;

  /**
   * Crea una instancia para header component.
   * @param router 
   * @param commonService 
   */
  constructor(private router: Router, private commonService: CommonsService) { }

  /**
   * on init - inicializa el icono del header en función de la página
   */
  ngOnInit() {
    this.hideIcon = window.location.href.includes('faqs') || window.location.href.includes('terms-conditions')
      || window.location.href.includes('privacy-polity');
    this.showIconConsumer();
  }

  /**
   * Va a la url anterior
   */
  backView() {
    this.router.navigateByUrl(this.commonService.getCurrentUrl());
  }

  /**
   * Guarda la url en el pool de navegación
   */
  saveUrl() {
    this.commonService.setCurrentUrl(this.router.url);
  }

  /**
   * Redirige a la home
   * @param check 
   * @returns  
   */
  goToHome(check) {
    if (!check) {
      return;
    }
    this.router.navigateByUrl('/home');
  }

  /**
   * Muestra el icono de Santander Consumer en función de una propiedad del storage
   */
  showIconConsumer() {
    const v = JSON.parse(sessionStorage.getItem('getParams'));
    this.showIcon = v ? v[0] : 1;
  }
}
